export default __webpack_public_path__ + "static/yellow-48699c3cd3d56fdbae6b9ea3cb202adb.mp3";